import React from 'react';
import { Card, Tabs, Divider } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { Creators } from '~/stores/ducks/general/tabs';
import { TabPane, Modal, ParamPage } from './components';
import './Page.less';

class Page extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  renderExtra = () => {
    const { tabbed, extraHeader, paramPage } = this.props;

    return (
      <div className={classNames({ 'page-extra-tabbed': tabbed === true })}>
        {extraHeader ? (
          <>
            {extraHeader}
            <Divider type="vertical" />
          </>
        ) : null}
        {paramPage ? (
          <>
            <ParamPage paramPage={paramPage} />
            <Divider type="vertical" />
          </>
        ) : null}
      </div>
    );
  };

  render() {
    const { tabbed, footer, children, showExtra = true, onChange, activeKey, title, className, bodyStyle } = this.props;

    if (!tabbed) {
      return (
        <Card
          bodyStyle={{ ...(bodyStyle || {}) }}
          extra={showExtra && this.renderExtra()}
          className={classNames('card-header-page', className)}
          title={title || ''}
        >
          {children}
          {footer && <div className="page-footer">{footer}</div>}
        </Card>
      );
    }

    return (
      <Page bodyStyle={{ padding: 0, ...(bodyStyle || {}) }} footer={footer} showExtra={false}>
        <Tabs
          className="page-tabs"
          renderTabBar={({ ...tabBarProps }, DefaultTabBar) => <DefaultTabBar className={classNames(className, 'page-tabs-tab-bar')} {...tabBarProps} />}
          tabBarExtraContent={this.renderExtra()}
          onChange={onChange}
          activeKey={activeKey}
        >
          {children}
        </Tabs>
      </Page>
    );
  }
}

Page.TabPane = TabPane;
Page.Modal = Modal;

const mapDispatchToProps = dispatch => bindActionCreators(Creators, dispatch);
const mapStateToProps = ({ general }) => ({ general });
export default connect(mapStateToProps, mapDispatchToProps)(Page);
